export interface GroupSelectOption {
  id: number
  label: string
  groupId?: string | number
}
export interface GroupSelectGroupOption {
  id: number
  label: string
  options: GroupSelectOption[]
  groupId?: string | number
}
export interface GroupSelectOptGroupOption {
  id: string
  label: string
}

export const fakeOptions: GroupSelectOption[] = [
  {
    id: 5139977,
    label: 'Cat',
    groupId: '2',
  },
  {
    id: 1037291,
    label: 'Dog',
    groupId: '2',
  },
  {
    id: 3733119,
    label: 'Parrot',
    groupId: '2',
  },
  {
    id: 1279548,
    label: 'Cow',
    groupId: '2',
  },
  {
    id: 5136274,
    label: 'Lion',
    groupId: '2',
  },
  {
    id: 1360365,
    label: 'Wolf',
    groupId: '2',
  },
  {
    id: 2142072,
    label: 'Pig',
    groupId: '2',
  },
  {
    id: 4177019,
    label: 'Giraffe',
    groupId: '2',
  },
  {
    id: 1819065,
    label: 'Owl',
    groupId: '2',
  },
  {
    id: 3116635,
    label: 'Crocodile',
    groupId: '2',
  },
  {
    id: 1987946,
    label: 'Elephant',
    groupId: '2',
  },
  {
    id: 1690,
    label: 'Duck',
    groupId: '2',
  },
  {
    id: 10338,
    label: 'Frog',
    groupId: '2',
  },
  {
    id: 1665038,
    label: 'Fox',
    groupId: '2',
  },
]

export const fakeGroups: GroupSelectGroupOption[] = [
  {
    id: 180604,
    label: 'Group #1',
    options: [
      {
        id: 5139977,
        label: 'Cat',
        groupId: '2',
      },
      {
        id: 1037291,
        label: 'Dog',
        groupId: '2',
      },
      {
        id: 1279548,
        label: 'Cow',
        groupId: '2',
      },
      {
        id: 1690,
        label: 'Duck',
        groupId: '2',
      },
    ],
    groupId: '1',
  },
  {
    id: 187138,
    label: 'Group #2',
    options: [
      {
        id: 1665038,
        label: 'Fox',
        groupId: '2',
      },
      {
        id: 10338,
        label: 'Frog',
        groupId: '2',
      },
    ],
    groupId: '1',
  },
  {
    id: 127496,
    label: 'Group #3',
    options: [
      {
        id: 1987946,
        label: 'Elephant',
        groupId: '2',
      },
      {
        id: 1819065,
        label: 'Owl',
        groupId: '2',
      },
    ],
    groupId: '1',
  },
  {
    id: 126261,
    label: 'Group #4',
    options: [
      {
        id: 3116635,
        label: 'Crocodile',
        groupId: '2',
      },
    ],
    groupId: '1',
  },
]

export const fakeOptGroups: GroupSelectOptGroupOption[] = [
  {
    id: '1',
    label: 'Distribution Group',
  },
  {
    id: '2',
    label: 'Animals',
  },
]
